import {
  collectionsData,
  fetchCollections,
} from '~/js/utilities/products-and-collections';

import { normalizeFilterValue } from '../sections/products-browser/utils';

const SHOW_BY_DEFAULT = 6;
const SWATCH_CROP = '&width=128&height=128&crop=center';

const getSwatch = (ctx, value) => {
  const swatch = ctx.colorSwatches[value.value];
  if (swatch?.image) {
    const url = swatch.image?.src || swatch.image;

    if (url) {
      return {
        image: `url(${url}${SWATCH_CROP})`,
      };
    }
  }

  return swatch || {};
};

const getCollectionData = (ctx, value) => {
  const id = value.value;
  const collection = collectionsData[id];

  if (!collection) {
    ctx.printCollectionsState[id] = 'loading';

    fetchCollections([id]).then(() => {
      ctx.printCollectionsState[id] = 'loaded';
    });
  }

  const swatchUrl = collection?.iconImage?.reference?.image?.url;

  return {
    // ctx.printCollectionsState is used just to force reactivity
    state: ctx.printCollectionsState[id],
    label: collection?.iconTitle?.value || collection?.title,
    swatch: {
      image: swatchUrl && `url(${swatchUrl}${SWATCH_CROP})`,
      backgroundSize: '125%',
    },
  };
};

export const normalizeFacetValues = (ctx, facet, values) => {
  const isPalette = facet.type === 'palette';
  const isPrintCollection = facet.field == 'mfield_custom_print_collection';

  return values.map((value) => {
    const collectionData = isPrintCollection
      ? getCollectionData(ctx, value)
      : null;

    return {
      ...value,
      value: normalizeFilterValue(value),
      label: isPrintCollection ? collectionData?.label || '' : value.label,
      swatch:
        isPalette && isPrintCollection
          ? collectionData?.swatch
          : isPalette
          ? getSwatch(ctx, value)
          : null,
    };
  });
};

export const handleFacetOnChange = (facet, value, event) => {
  if (facet.multiple === 'single') {
    const { target } = event;
    const val = target._x_model.get();
    if (Array.isArray(val) && val.includes(value.value)) {
      target._x_model.set([value.value]);
    }
  }
};

const productsBrowserFacet = () => ({
  expanded: false,
  showInSteps: false,
  itemsToShow: SHOW_BY_DEFAULT,
  showAll: false,

  get label() {
    return this.facet.label;
  },

  get showByDefault() {
    if (this.facet.field.includes('size')) {
      return Infinity;
    }

    return SHOW_BY_DEFAULT;
  },

  get hasMoreToggle() {
    return this.facet.values.length > this.showByDefault;
  },

  get values() {
    const limited = this.showAll
      ? this.facet.values
      : this.facet.values.slice(
          0,
          this.showInSteps ? this.itemsToShow : this.showByDefault
        );

    if (this.showInSteps && !this.showAll) {
      // preload next set of carousel items
      fetchCollections(
        this.facet.values
          .slice(0, this.itemsToShow + SHOW_BY_DEFAULT)
          .map((val) => val.value)
      ).catch(() => {});
    }

    return normalizeFacetValues(this, this.facet, limited);
  },

  init() {
    this.expanded = this.facet.collapse === 0;
    this.showInSteps = this.label === 'Print';
  },

  onChange(facet, value, event) {
    handleFacetOnChange(facet, value, event);

    const sizeLabel = value?.label?.trim();
    if (!sizeLabel) return;

    const chip = document.querySelector(`.size-filter-label[data-size="${sizeLabel}"]`);

    if (chip) {
      if(chip.classList.contains("selected")) {
        chip.classList.remove("selected");
      } else{
        chip.classList.add("selected");
      }
    } else {
    }
  },

  handleShowMoreClick() {
    if (!this.showInSteps || this.showAll) {
      this.showAll = !this.showAll;
      return;
    }

    if (this.facet.field.includes('print')) {
      this.showAll = true;
      return Infinity;
    }

    this.itemsToShow += SHOW_BY_DEFAULT;
    if (this.itemsToShow >= this.facet.values.length) {
      this.showAll = true;
      this.itemsToShow = 6;
    }
  },
});

export default productsBrowserFacet;
